import React, { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Dropdown } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddOutlinedIcon from "@material-ui/icons/GroupAddOutlined";
// import InsertInvitationOutlinedIcon from "@material-ui/icons/InsertInvitationOutlined";
import { Card } from "react-bootstrap";
import MuiAlert from "@material-ui/lab/Alert";
import { AssignCoach } from "./AssignCoach";
import SeeCoach from "./SeeCoach";
import { SeeClients } from "./SeeClients";
import Tooltip from '@material-ui/core/Tooltip';

import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Box,
  makeStyles,
  Typography,
  ButtonGroup,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  FetchUsersList,
  AssignNewCoach,
  FetchCoacheList,
  FetchOrganizationList,
  AddUser,
  BlockUnBlock,
  DeleteUser,
  UpdateType
} from "../apis";
import { ClientProfile } from "./ClientProfile";
import InputAdornment from "@material-ui/core/InputAdornment";
import { JobseekerPurchaseHistory } from "./JobseekerPurchaseHistory";


// users list
const GET_USERS_LIST = gql`
  query Query(
    $getAllUsersListPageNo: Int
    $getAllUsersListLimit: Int
    $getAllUsersListSearchText: String
  ) {
    getAllUsersList(
      pageNo: $getAllUsersListPageNo
      limit: $getAllUsersListLimit
      searchText: $getAllUsersListSearchText
    ) {
      usersList {
        id
        firstName
        lastName
        email
        isBlocked
        type
        invitedBy
      }
      usersCount
      pageNo
    }
  }
`;

// add client
const ADD_CLIENT = gql`
  mutation Mutation(
    $sendCoachInvitationEmail: String!
    $sendCoachInvitationFirstName: String!
    $sendCoachInvitationLastName: String!
    $sendCoachInvitationType: String!
  ) {
    sendCoachInvitation(
      email: $sendCoachInvitationEmail
      firstName: $sendCoachInvitationFirstName
      lastName: $sendCoachInvitationLastName
      type: $sendCoachInvitationType
    ) {
      code
      success
      message
    }
  }
`;
// block mutation
const BLOCK_USER = gql`
  mutation Mutation($blockUserUserId: String) {
    blockUser(userId: $blockUserUserId) {
      code
      success
      message
    }
  }
`;

const UNBLOCK_USER = gql`
  mutation Mutation($unblockUserUserId: String) {
    unblockUser(userId: $unblockUserUserId) {
      code
      success
      message
    }
  }
`;
// unblock mutation

// css
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "40px",
    align: "left",
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f2f2f2",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));
// end of css

let headers = [
  "Client Name",
  "Email",
  "Phone",
  "Organization",
  "Stage",
  "Status",
  "Type",
  "Client/Coach",
  "Action",
];

// let rows = [];
// let count;
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export function ClientListTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearchText] = React.useState("");
  const [DialogState, setDialogState] = React.useState(false);
  const [userId, setUserIdForBlock] = React.useState("");
  const [blockedUser, setUserNameForBlock] = React.useState("");
  const [rows, setRows] = useState([]);
  const [coaches, setCoaches] = useState([]);
  const [oragnizations, setOrganizations] = useState([]);
  const [filter, setFilter] = React.useState("");
  const [sort, setSort] = React.useState(1);
  const [count, setCount] = useState(14)

  const { data, refetch } = useQuery(GET_USERS_LIST, {
    variables: {
      getAllUsersListPageNo: page,
      getAllUsersListLimit: rowsPerPage,
      getAllUsersListSearchText: search,
    },
  });

  const [snackBarText, setSnackBarText] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackBarVariant, setSnackBarVariant] = React.useState("success");

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [userType, setUserType] = React.useState("");
  const [addClientLoader, setAddClientLoader] = React.useState(false);
  const [assigningCoach, setAssigningCoach] = React.useState(false);
  const [assignCoach, setAssignCoach] = React.useState(false);
  const [seeCoach, setSeeCoach] = React.useState(false);
  const [seeJobSeeker, setSeeJobSeeker] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState("");
  const [selectedJs, setSelectedJs] = React.useState();
  const [seeUserModal, setSeeUserModal] = React.useState(false);

  const [coachSearch, setCoachSearch] = React.useState("");
  const [selectedCoach, setSelectedCoach] = React.useState();

  const [organizationSearch, setOrganizationSearch] = React.useState("");
  const [selectedOrganization, setSelectedOrganization] = React.useState();

  const [addClient] = useMutation(ADD_CLIENT, {
    onCompleted(addClient) {
      setSnackBarVariant("success");
      setSnackBarText("Invitation sent successfully");
      setSnackBarOpen(true);
      setAddClientLoader(false);
      setDialogState(false);
      fetchUsers(page, rowsPerPage, search, sort, filter);
    },
  });
  const [blockUser] = useMutation(BLOCK_USER, {
    variables: {
      blockUserUserId: userId,
    },
    onCompleted() {
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("error");
      setSnackBarText("you have blocked " + blockedUser);
      setSnackBarOpen(true);
    },
  });

  const [unBlockUser] = useMutation(UNBLOCK_USER, {
    variables: {
      unblockUserUserId: userId,
    },
    onCompleted() {
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("success");
      setSnackBarText("you have unblocked " + blockedUser);
      setSnackBarOpen(true);
    },
  });

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const searchText = (event) => {
    setSearchText(event.target.value);

    if (event.target.value.length > 2) {
      fetchUsers(page, rowsPerPage, event.target.value, sort, filter);
      setPage(0)
    } else if (event.target.value.length === 0)
      fetchUsers(page, rowsPerPage, event.target.value, sort, filter);
      setPage(0)
  };

  const [changeTypeUserId, setChangeTypeUserId] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchUsers(newPage, rowsPerPage, search, sort, filter);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // fetchUsers();
  };

  const handleDialogOpen = () => {
    setDialogState(true);
  };

  const handleDialogClose = () => {
    setDialogState(false);
  };
  const classes = useStyles();

  const refreshUsers = () => {
    fetchUsers(page, rowsPerPage, search, sort, filter);
  }

  const handleBlock = async (id, name) => {
    setUserIdForBlock(id);
    setUserNameForBlock(name);
    let res = await BlockUnBlock(id, true);

    fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("error");
      setSnackBarText("you have blocked " + name);
      setSnackBarOpen(true);
    // setUserIdForBlock(id);
    // setUserNameForBlock(name);
    // blockUser({
    //   variables: { blockUserUserId: id },
    // });
  };
  const handleUnBlock = async (id, name) => {
    setUserNameForBlock(name);

    setUserIdForBlock(id);
    // unBlockUser({
    //   variables: { unblockUserUserId: id },
    // });
    let res = await BlockUnBlock(id, true);
    fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("success");
      setSnackBarText("you have unblocked " + name);
      setSnackBarOpen(true);
  };

  const handleDeleteUser = async (id, name) => {
    setUserNameForBlock(name);

    setUserIdForBlock(id);
    // unBlockUser({
    //   variables: { unblockUserUserId: id },
    // });
    let res = await DeleteUser(id);
    fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("success");
      setSnackBarText("User " + name + " deleted successfully");
      setSnackBarOpen(true);
  }
  const handleFirstName = (evt) => {
    setFirstName(evt.target.value);
  };
  const handleLastName = (evt) => {
    setLastName(evt.target.value);
  };
  const handleEmail = (evt) => {
    setEmail(evt.target.value);
  };

  const hanldeUserType = (evt) => {
    setUserType(evt.target.value);
  };
  const handleAddClient = async () => {
    if (!userType) {
      setSnackBarVariant("error");
      setSnackBarText("User Type is Required");
    }
    setAddClientLoader(true);

    let data = {
      email,
      firstName,
      lastName,
      email,
      type: userType,
      ...(selectedCoach && selectedCoach._id
        ? { invitedBy: selectedCoach._id }
        : {}),
      ...(selectedOrganization && selectedOrganization._id
        ? { organization: selectedOrganization._id }
        : {}),
    };

    let addUser = await AddUser(data);
    if (addUser.data.success) {
      setSnackBarOpen(true);
      setSnackBarVariant("success");
      setSnackBarText("Invitation sent successfully");
      handleDialogClose();
      // refetch()
      fetchUsers(page, rowsPerPage, search, sort, filter);
    } else {
      setSnackBarOpen(true);
      setSnackBarVariant("error");
      setSnackBarText(addUser.data.message);
      
    }
    setAddClientLoader(false);
    // addClient({
    //   variables: {
    //     sendCoachInvitationEmail: email,
    //     sendCoachInvitationFirstName: firstName,
    //     sendCoachInvitationLastName: lastName,
    //     sendCoachInvitationType: userType
    //   },
    // });
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  // if (typeof data === "object") {
  //   count = parseInt(data.getAllUsersList.usersCount);
  //   rows = data.getAllUsersList.usersList.map((key) => {
  //     var blockStatus;
  //     if (key.isBlocked) {
  //       blockStatus = "Blocked";
  //     } else {
  //       blockStatus = "Active";
  //     }
  //     console.log("key:-=-=", key)
  //     return {
  //       id: key.id,
  //       name: key.firstName + " " + key.lastName,
  //       email: key.email,
  //       phone: "N/A",
  //       stage: "Needs Resume Review",
  //       status: blockStatus,
  //       action: key.isBlocked,
  //       type: key.type === "JOB_SEEKER" ? 'Job Seeker' : "Coach"
  //     };
  //   });
  // }

  React.useEffect(() => {
    fetchUsers(page, rowsPerPage, search, sort, filter);
    FetchCoaches();
    FetchOrganizations();
  }, {});

  const FetchCoaches = async (s = "") => {
    let result = await FetchCoacheList(s ? s : "");
    setCoaches([...result.data.users]);
  };

  const FetchOrganizations = async (s = "") => {
    let result = await FetchOrganizationList(s ? s : "");
    setOrganizations([...result.data.organizations]);
  };

  const fetchUsers = async (p, r, s, st, f) => {
    let result = await FetchUsersList(p, r, s, st, f === "All" ? "" : f);
    console.log("result: ", result.data);
    let newRows = result.data.users.map((key) => {
      var blockStatus;
      if (key.isBlocked) {
        blockStatus = "Blocked";
      } else {
        blockStatus = "Active";
      }
      let organization = 'N/A';
      if(key.organization && key.organization.name){
        organization = key.organization.name
      }
      console.log("key:-=-=", key);
      return {
        id: key._id,
        name: key.firstName + " " + key.lastName,
        email: key.email,
        organization,
        phone: key.cellPhone ? key.cellPhone : "N/A",
        stage: "Needs Resume Review",
        status: blockStatus,
        action: key.isBlocked,
        type: key.type === "JOB_SEEKER" ? "Job Seeker" : "Coach",
        invitedBy: key.invitedBy,
      };
    });

    setRows([...newRows]);
    setCount(result.data.count);
  };

  const onSelectCategory = (evt) => {
    setFilter(evt.target.value);
    fetchUsers(page, rowsPerPage, search, sort, evt.target.value);
    setPage(0)
  };

  const openAssignCoach = (data) => {
    setAssignCoach(true);
    setSelectedJs(data);
  };

  const closeAssignCoach = () => {
    setAssignCoach(false);
    setSelectedJs(undefined);
  };

  const onAssigngingCoach = async (data) => {
    setAssigningCoach(true);
    let update = await AssignNewCoach(data);
    closeAssignCoach();
    setAssigningCoach(false);
    fetchUsers(page, rowsPerPage, search, sort, filter);
  };

  const openSeeClientPopup = (id) => {
    setSeeJobSeeker(true);
    setSelectedUser(id);
  };

  const closeSeeClientPopup = () => {
    setSeeJobSeeker(false);
    setSelectedUser("");
  };

  const openSeeCoach = (id) => {
    setSeeCoach(true);
    setSelectedUser(id);
  };

  const closeSeeCoach = (id) => {
    setSeeCoach(false);
    setSelectedUser("");
  };

  const openUserDetails = (data) => {
    // console.log("Dayta", data);
    setSeeUserModal(true);
    setSelectedJs(data);
  };

  const closeUserDetails = (data) => {
    setSeeUserModal(false);
    setSelectedJs(undefined);
  };

  const onChangesCoachesSearch = (evt) => {
    setCoachSearch(evt);
    FetchCoaches(evt);
  };
  const onChangesOrganizationsSearch = (evt) => {
    setOrganizationSearch(evt);
    FetchOrganizations(evt);
  };

  const handleChangeType = async (id, type) => {
    setChangeTypeUserId(id)
    let res = await UpdateType(id, type)
    fetchUsers(page, rowsPerPage, search, sort, filter);
    setChangeTypeUserId(null)
      setSnackBarVariant("success");
      setSnackBarText(res.message);
      setSnackBarOpen(true);
  }

  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null)

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <Grid container direction="columnm" className="px-5">
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder="Search client by name, email and phone"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                  onChange={searchText}
                />
              </div>
            </Grid>
            <Grid item>
              <FormControl
                style={{
                  width: 130,
                  marginTop: -5,
                }}
              >
                <InputLabel id="demo-simple-select-label1">
                  Select Category
                </InputLabel>
                <Select
                  label="filter"
                  labelId="demo-simple-select-label1"
                  id="demo-simple-select"
                  value={filter}
                  onChange={onSelectCategory}
                >
                  <MenuItem value="All" selected>
                    All
                  </MenuItem>
                  <MenuItem value="BLOCKED">Blocked Users</MenuItem>
                  <MenuItem value="COACHES">Coaches</MenuItem>
                  <MenuItem value="JOB_SEEKERS">Job Seekers</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <div>
                <div>
                  <FormControl
                    style={{
                      marginTop: -5,
                    }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Select Sort
                    </InputLabel>
                    <Select
                      label="filter"
                      // className="form-control border-0 form-control-solid py-5 px-6 my-3"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sort}
                      onChange={(evt) => {
                        setSort(evt.target.value);
                        fetchUsers(
                          page,
                          rowsPerPage,
                          search,
                          evt.target.value,
                          filter
                        );
                      }}
                    >
                      <MenuItem value={1}>Ascending Order</MenuItem>
                      <MenuItem value={-1}>Descending Order</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                className={classes.button}
                startIcon={<GroupAddOutlinedIcon style={{ fontSize: 25 }} />}
                onClick={handleDialogOpen}
              >
                <Typography className="px-3" variant="h6">
                  Add New Client
                </Typography>
              </Button>
            </Grid>
          </Grid>
          <Grid item>
            <Snackbar
              open={snackBarOpen}
              autoHideDuration={5000}
              onClose={handleSnackBarClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Alert
                onClose={handleSnackBarClose}
                style={{
                  fontSize: "16px",
                  backgroundColor: snackBarVariant === "error" ? "red" : "",
                }}
                severity={snackBarVariant}
              >
                {snackBarText}
              </Alert>
            </Snackbar>
          </Grid>
          <Grid item>
            <Dialog
              open={DialogState}
              onClose={handleDialogClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              fullWidth="100%"
            >
              <DialogTitle id="form-dialog-title">
                <Typography variant="h6">ADD NEW CLIENT</Typography>
              </DialogTitle>
              <DialogContent>
                {/* <Select
                  label="type"
                  className="form-control border-0 form-control-solid py-5 px-6 my-3"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={userType}
                  onChange={hanldeUserType}
                >
                  <MenuItem value={"COACH"}>Coach</MenuItem>
                  <MenuItem value={"JOB_SEEKER"}>Job Seeker</MenuItem>
                </Select> */}

                <FormControl>
                  {/* <FormLabel id="demo-row-radio-buttons-group-label">
                    <Typography variant="h6">Gender
                    </Typography></FormLabel> */}
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onClick={hanldeUserType}
                  >
                    <FormControlLabel
                      value="ADMIN"
                      control={<Radio />}
                      label="Admin"
                    />
                    <FormControlLabel
                      value="COACH"
                      control={<Radio />}
                      label="Career Coach"
                    />
                    <FormControlLabel
                      value="JOB_SEEKER"
                      control={<Radio />}
                      label="Client"
                    />
                  </RadioGroup>
                </FormControl>

                {userType === "JOB_SEEKER" && (
                  <Grid item className="py-2 ">
                    {/* <div className={classes.search}>
                    <div className={classes.searchIcon}>
                      <SearchIcon />
                    </div> */}
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={coaches}
                      getOptionLabel={(option) =>
                        `${option.firstName.toString()} ${option.lastName.toString()}`
                      }
                      onChange={(evt, newV) => setSelectedCoach(newV)}
                      sx={{ width: 300 }}
                      inputValue={coachSearch}
                      onInputChange={(event, newInputValue) =>
                        onChangesCoachesSearch(newInputValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search Coach Name"
                        //  inputProps={{
                        //   startAdornment: (
                        //     <InputAdornment position="start">
                        //       <SearchIcon />
                        //     </InputAdornment>
                        //   ),
                        // }}
                        />
                      )}
                    />
                    {/* </div> */}
                  </Grid>
                )}

                <Grid item className="py-2 ">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={oragnizations}
                    getOptionLabel={(option) => `${option.name.toString()}`}
                    onChange={(evt, newV) => setSelectedOrganization(newV)}
                    sx={{ width: 300 }}
                    inputValue={organizationSearch}
                    onInputChange={(event, newInputValue) =>
                      onChangesOrganizationsSearch(newInputValue)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Search Organization"
                      />
                    )}
                  />
                </Grid>

                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  autoFocus
                  margin="dense"
                  placeholder="First Name"
                  type="text"
                  onChange={handleFirstName}
                  required
                />
                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  margin="dense"
                  id="lname"
                  placeholder="Last Name"
                  type="text"
                  onChange={handleLastName}
                  required
                />
                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  margin="dense"
                  id="email"
                  placeholder="Email Address"
                  type="email"
                  onChange={handleEmail}
                  required
                />
              </DialogContent>
              <DialogActions>
                <Grid
                  className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                >
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleDialogClose}
                      variant={"contained"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleAddClient}
                      color="secondary"
                      variant={"contained"}
                      className="px-10"
                      disabled={
                        firstName.length && lastName.length && email.length
                          ? false
                          : true
                      }
                    >
                      {addClientLoader ? (
                        <CircularProgress
                          size="20px"
                          style={{ color: "#ffffff" }}
                        />
                      ) : (
                        <Typography>Add</Typography>
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>

        <TableContainer className="mt-10">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headers.map((item, index) => (
                  <TableCell
                    key={index}
                    align="left"
                    classes={{ root: classes.tableHeadCell }}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <StyledTableRow key={index}>
                  <TableCell
                    classes={{
                      root: classes.tableRowCell,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                    onClick={() => openUserDetails(row)}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.email}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.phone}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.organization}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.stage}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.status}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    <Tooltip title={row.type == "Coach" ? "Click to change type to Jobseeker" : "Click to change type to Coach"} arrow>
                      <Button disabled={row.id == changeTypeUserId} variant="outlined" onClick={()=>{handleChangeType(row.id, row.type == "Coach" ? "JOB_SEEKER" : "COACH")}}>{changeTypeUserId == row.id ? <CircularProgress size="17px" className="mx-7 " /> : row.type}</Button>
                    </Tooltip>
                    {/* {row.type} */}
                    
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {
                      row.type === "Coach" ? (
                        <Button
                          variant="outlined"
                          onClick={() => openSeeClientPopup(row.id)}
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#28d604",
                            borderColor: "#28d604",
                            // width: 'max-content'
                          }}
                        >
                          <Typography>See Client</Typography>
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          onClick={() => openAssignCoach(row)}
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#28d604",
                            borderColor: "#28d604",
                            // width: 'max-content'
                          }}
                        >
                          {assigningCoach ? (
                            <CircularProgress size="17px" className="mx-7 " />
                          ) : (
                            <Typography>
                              {row.invitedBy ? "See Coach" : "Assign"}
                            </Typography>
                          )}
                        </Button>
                      )
                      // <SeeCoach selectedUser={row.invitedBy} />
                      // <Button
                      //   variant="outlined"
                      //   onClick={() => openSeeCoach(row.invitedBy)}
                      //   style={{
                      //     backgroundColor: "#ffffff",
                      //     color: "#28d604",
                      //     borderColor: "#28d604",
                      //     // width: '100px'
                      //   }}
                      // >
                      //   <Typography>See Coach</Typography>
                      // </Button>
                    }
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {/* <Dropdown as={ButtonGroup}>
                      <Dropdown.Toggle id="dropdown-basic" className="border">
                        {" actions "}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          lineHeight: 0,
                          left: -100,
                          top: 40,
                        }}
                      >
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Block
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Unblock
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                   */}

                    {row.action ? (
                      <Button
                        variant="outlined"
                        onClick={() => {
                          handleUnBlock(row.id, row.name);
                        }}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#28d604",
                          borderColor: "#28d604",
                        }}
                      >
                        {userId === row.id ? (
                          <CircularProgress size="17px" className="mx-7 " />
                        ) : (
                          <Typography>Unblock</Typography>
                        )}
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        style={{
                          borderColor: "#fc7e7e",
                          color: "#fc7e7e",
                          backgroundColor: "#ffffff",
                        }}
                        onClick={() => {
                          handleBlock(row.id, row.name);
                        }}
                        className="pl-7 pr-8"
                      >
                        {userId === row.id ? (
                          <CircularProgress
                            size="18px"
                            style={{ color: "#fc7e7e" }}
                            className="mx-4 "
                          />
                        ) : (
                          <Typography>Block</Typography>
                        )}
                      </Button>
                    )}
                    <Button
                        variant="outlined"
                        onClick={() => {
                          handleDeleteUser(row.id, row.name);
                        }}
                        style={{
                          borderColor: "#fc7e7e",
                          color: "#fc7e7e",
                          backgroundColor: "#ffffff",
                          marginLeft: "5px"
                        }}
                      >
                        {userId === row.id ? (
                          <CircularProgress size="17px" className="mx-7 " />
                        ) : (
                          <Typography>Delete</Typography>
                        )}
                      </Button>
                      { row.type == "Job Seeker" && <Button
                      variant="outlined"
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#28d604",
                        borderColor: "#28d604",
                      }}
                      onClick={() => {
                        setSelectedJobSeeker(row.id);
                        // handleBlock(row.id, row.name);
                      }}
                      className="pl-7 pr-8"
                    >
                       <Typography>Purchase History</Typography>
                    </Button> }
                  </TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
            <TablePagination
              count={count}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>
        {assignCoach && (
          <AssignCoach
            selectedJobSeeker={selectedJs}
            open={AssignCoach}
            onClose={closeAssignCoach}
            onAssigngingCoach={onAssigngingCoach}
          />
        )}
        {seeJobSeeker && (
          <SeeClients
            open={seeJobSeeker}
            onClose={closeSeeClientPopup}
            selectedUser={selectedUser}
          />
        )}
        {seeUserModal && selectedJs && (
          <ClientProfile
            user={selectedJs}
            onClose={closeUserDetails}
            open={seeUserModal}
            refreshUsers={refreshUsers}
          />
        )}
        {selectedJobSeeker && <JobseekerPurchaseHistory id={selectedJobSeeker} setSelectedJobSeeker={setSelectedJobSeeker} />}
      </Card.Body>
    </Card>
    // </Box>
  );
}
